module.exports = __webpack_public_path__ + "static/media/deleteMenux.e0a629b4.svg";